export * from './ActorQueryOperationQuadpattern';
